// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__YdBAO","img":"footer_img__gKRjr","askBetko":"footer_askBetko__Puw75"};